import { useState, useEffect, useRef } from "react";


const distanceCache = new Map();

function makeCacheKey(uLat, uLng, pLat, pLng) {
    return `${(+uLat).toFixed(4)},${(+uLng).toFixed(4)}`
        + `>${(+pLat).toFixed(4)},${(+pLng).toFixed(4)}`;
}

function haversine(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
        + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180)
        * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function getStyle(km) {
    if (km <= 2)  return { background: "#dcfce7", color: "#166534" };
    if (km <= 10) return { background: "#dbeafe", color: "#1e40af" };
    return          { background: "#f3f4f6", color: "#6b7280" };
}

export default function PropertyDistanceBadge({ userLat, userLng, propLat, propLng, style = {} }) {
    const [label, setLabel] = useState(null);
    const didCalc = useRef(false);

    useEffect(() => {
        if (userLat == null || userLng == null || propLat == null || propLng == null) return;
        const uLat = parseFloat(userLat), uLng = parseFloat(userLng);
        const pLat = parseFloat(propLat), pLng = parseFloat(propLng);
        if ([uLat, uLng, pLat, pLng].some(isNaN)) return;
        if (uLat === 0 && uLng === 0) return;
        if (pLat === 0 && pLng === 0) return;

        const key = makeCacheKey(uLat, uLng, pLat, pLng);
        if (distanceCache.has(key)) { setLabel(distanceCache.get(key)); return; }
        if (didCalc.current) return;
        didCalc.current = true;

        const km = haversine(uLat, uLng, pLat, pLng);
        const text = km < 1 ? `~${Math.round(km * 1000)} m` : `~${km.toFixed(1)} km`;
        distanceCache.set(key, text);
        setLabel(text);
    }, [userLat, userLng, propLat, propLng]);

    if (!label) return null;

    const numKm = parseFloat(label.replace(/[~km m]/g, "")) || 0;
    const urgency = getStyle(label.includes(" m") ? 0.3 : numKm);

    return (
        <span style={{
            display: "inline-flex", alignItems: "center", gap: 4,
            padding: "3px 8px", borderRadius: 20,
            fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
            ...urgency, ...style,
        }}>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <circle cx="12" cy="10" r="3"/>
          <path d="M12 2a8 8 0 0 1 8 8c0 5.25-8 12-8 12S4 15.25 4 10a8 8 0 0 1 8-8z"/>
        </svg>
            {label} away
      </span>
    );
}
